import { FunctionComponent, createElement, lazy } from 'react';

export const HomePath: string = '/';
export const ContactPath: string = '/contact';
export const LiveLensPath: string = '/livelens';
export const PrivacyPolicyPath: string = '/legal/privacy';
export const TermsOfServicePath: string = '/legal/terms';

export interface Route {
	path: string;
	element: React.ReactNode;
}

const loader = (loader: () => Promise<{ default: FunctionComponent<{}>}>) => {
	return createElement(lazy(loader));
}

export const Routes: Route[] = [
	{ path: HomePath, element: loader(() => import('@pages/Home')) },
	{ path: ContactPath, element: loader(() => import('@pages/Contact')) },
	{ path: LiveLensPath, element: loader(() => import('@pages/LiveLens')) },

	// Legal
	{ path: TermsOfServicePath, element: loader(() => import('@pages/TermsOfService')) },
	{ path: PrivacyPolicyPath, element: loader(() => import('@pages/PrivacyPolicy')) },

	// 404 Not Found
	{ path: '*', element: loader(() => import('@pages/NotFound')) },
]
